import React from 'react'
export default function Cart({ cart, updateQty, clearCart }) {
    const total = cart.reduce((s, p) => s + p.price * p.qty, 0)
    return (
        <div className="container">
            <h1>Your Cart</h1>
            {cart.length === 0 ? (
                <p>Your cart is empty.</p>
            ) : (
                <div>
                    <table className="cart-table">
                        <thead>
                            <tr><th>Product</th><th>Qty</th><th>Price</th><th>Subtotal</th></tr>
                        </thead>
                        <tbody>
                            {cart.map(item => (
                                <tr key={item.id}>
                                    <td className="product-cell">
                                        <img src={item.image} alt="" />
                                        <div>{item.name}</div>
                                    </td>
                                    <td>
                                        <input
                                            type="number"
                                            min="0"
                                            value={item.qty}
                                            onChange={e => updateQty(item.id, Math.max(0, Number(e.target.value)))}
                                        />
                                    </td>
                                    <td>${item.price.toFixed(2)}</td>
                                    <td>${(item.price * item.qty).toFixed(2)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <div className="cart-summary" style={{ marginTop: 18 }}>
                        <strong>Total: ${total.toFixed(2)}</strong>
                        <div>
                            {/* Checkout removed */}
                            <button onClick={clearCart} className="muted" style={{ marginLeft: 10 }}>
                                Clear Cart
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}